import { GeneralFieldController } from "./general-field-controller";
import { ControlState } from "../models/flexible/control-state";
import { AttributeIdentifiers } from "@lyfegen-platform/graphql-schema/models";

export class ExternalFormIdFieldController extends GeneralFieldController {
	override useControlState(): ControlState {
		return this.parent.context.noPatients && this.parent.context.noPatients > 0 ? "hidden" : "enabled";
	}

	override mapInitialValue(value: unknown): unknown {
		return (
			value ||
			this.parent.context.startingPoint?.data[AttributeIdentifiers.ExternalFormId as any] ||
			""
		);
	}
}
